export const environment = {
  production: true,
  showTestMessage: false,
  baseUrl: '/PnoChargerApi' 
};



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/environments/environment.ts